import React from "react";
import { useLodablePersonById } from "../../store/selectors/personSelectors";
import { isLoaded, isLoadErrored, isLoading } from "../../../../sg-core";
import { useTranslation } from "react-i18next";

interface IPersonNameProps {
    personId: number;
}

export const PersonName: React.FC<IPersonNameProps> = ({ personId }) => {

    const { t } = useTranslation();
    const person = useLodablePersonById(personId);

    if (!person || isLoadErrored(person)) {
        return <span>{t("Tuntematon henkilötunniste")} '{personId}'</span>
    }

    if (isLoading(person)) {
        return <span></span>;
    }

    return <span>{isLoaded(person) ? person.data.name : "-"}</span>;
};